var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import routeUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import "./views/DataSourceList/ducks/index.js";
import "./views/DataSourceDetail/ducks/index.js";
import { reducer as reducer$5 } from "./views/DataSourceDetail/ducks/DataSourceOverrideDetail.ducks.js";
import { reducer as reducer$2 } from "./views/DataSourceDetail/ducks/DataSourceAccess.ducks.js";
import { reducer as reducer$3 } from "./views/DataSourceDetail/ducks/DataSourceDetailSchema.ducks.js";
import { reducer as reducer$4 } from "./views/DataSourceDetail/ducks/DataSourceDetailHistory.ducks.js";
import { dataSourceProfilingReducer } from "./views/DataSourceDetail/ducks/DataSourceProfiling.ducks.js";
import { reducer as reducer$6 } from "./views/DataSourceDetail/ducks/DataSourceDetailOverrideList.ducks.js";
import { reducer as reducer$7 } from "./views/DataSourceDetail/ducks/DataSourceDetailStatus.ducks.js";
import { dataSourceDuplicateReducer } from "./views/DataSourceCreate/ducks/DataSourceDuplicate.ducks.js";
import { dataSourceFlightFormatsReducer } from "./views/DataSourceCreate/ducks/DataSourceFlightFormats.ducks.js";
import { dataSourceDeleteReducer } from "./views/DataSourceList/ducks/DataSourceDelete.ducks.js";
import { dataSourceCloneReducer } from "./views/DataSourceList/ducks/DataSourceClone.ducks.js";
import { combineReducers } from "redux";
import { DataSourceListReducer } from "./views/DataSourceList/ducks/DataSourceListFilter.ducks.js";
import { DataSourceDetailReducer } from "./views/DataSourceDetail/ducks/DataSourceDetailContext.ducks.js";
import { createDataSourceReducer } from "./views/DataSourceCreate/ducks/DataSourceCreate.ducks.js";
import { updateDataSourceReducer } from "./views/DataSourceCreate/ducks/DataSourceUpdate.ducks.js";
import { loadServicePrincipalNameListReducer } from "./views/DataSourceCreate/ducks/ServicePrincipalList.ducks.js";
import { loadManagedIdentityNameListReducer } from "./views/DataSourceCreate/ducks/ManagedIdentityList.ducks.js";
import "./views/DataSourceOverrideCreate/ducks/DataSourceCreate.ducks.js";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import LoadSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.ducks";
import SetSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks";
import LoadSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks";
import SetSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks";
import { reducer } from "./views/DataSourceList/ducks/DataSourceList.ducks.js";
import { reducer as reducer$1 } from "./views/DataSourceDetail/ducks/DataSourceDetail.ducks.js";
import { dataSourceCreateReducer } from "./views/DataSourceOverrideCreate/components/DataSourceCreateContainer/DataSourceCreateContainer.ducks.js";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, routeUpdateReducer), currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), LoadSubscribersReducersMapObject), SetSubscribersReducersMapObject), LoadSubscribersReducersMapObjectV2), SetSubscribersReducersMapObjectV2), {
  dataSourceManagementModule: combineReducers({
    dataSourceUpdate: updateDataSourceReducer,
    dataSourceCreate: createDataSourceReducer,
    dataSourceListState: DataSourceListReducer,
    dataSourceList: reducer,
    dataSource: reducer$1,
    dataSourceDetailState: DataSourceDetailReducer,
    dataSourceAccess: reducer$2,
    dataSourceSchema: reducer$3,
    dataSourceHistory: reducer$4,
    dataSourceOverride: reducer$5,
    dataSourceOverrideCreate: dataSourceCreateReducer,
    dataSourceOverrideList: reducer$6,
    dataSourceStatus: reducer$7,
    dataSourceDuplicate: dataSourceDuplicateReducer,
    dataSourceDelete: dataSourceDeleteReducer,
    dataSourceClone: dataSourceCloneReducer,
    dataSourceFlightFormats: dataSourceFlightFormatsReducer,
    dataSourceProfiling: dataSourceProfilingReducer,
    servicePrincipalList: loadServicePrincipalNameListReducer,
    managedIdentityList: loadManagedIdentityNameListReducer
  })
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
